export default __webpack_public_path__ + "static/media/avatar_cow4.8a73690a.mp3";